export enum SolutionColumn {
  LINE_OF_BUSINESS = 'lineOfBusiness',
  CATEGORY = 'category',
  REGION = 'region',
  TENANT = 'tenant'
}

export const solutionColumns = Object.values(SolutionColumn) as string[];
